export default function PHP_log10() {
  return (
    <div>
      <h1>PHP_log10</h1>
    </div>
  );
}
